var _rect, _rect2, _rect3, _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _g3, _path10, _path11, _path12, _g4, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g5, _path36, _path37, _path38, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainersImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 505,
    height: 441,
    viewBox: "0 0 505 441",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.16,
    x: 346.04,
    y: 405.854,
    width: 219.433,
    height: 109.555,
    rx: 11.9609,
    transform: "rotate(-180 346.04 405.854)",
    fill: "#7E81F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.16,
    x: 380.369,
    y: 44.1725,
    width: 34.3288,
    height: 23.4505,
    rx: 5.98044,
    transform: "rotate(-180 380.369 44.1725)",
    fill: "#7E81F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.16,
    x: 203.444,
    y: 440.844,
    width: 80.3279,
    height: 64.3808,
    rx: 11.9609,
    transform: "rotate(-180 203.444 440.844)",
    fill: "#7E81F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.052 256.246H46.231C20.6988 256.246 0.000976562 276.944 0.000976562 302.477V373.298C0.000976562 398.83 20.6988 419.528 46.231 419.528H117.052C142.584 419.528 163.282 398.83 163.282 373.298V302.477C163.282 276.944 142.584 256.246 117.052 256.246Z",
    fill: "#FE7B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.62 377.867C143.7 355.787 143.7 319.988 121.62 297.907C99.5399 275.827 63.7408 275.827 41.6605 297.907C19.5803 319.988 19.5803 355.787 41.6605 377.867C63.7408 399.947 99.5399 399.947 121.62 377.867Z",
    fill: "#F7D8BA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_299_832",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 281,
    width: 114,
    height: 114
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.62 377.867C143.7 355.787 143.7 319.988 121.62 297.907C99.5399 275.827 63.7408 275.827 41.6605 297.907C19.5803 319.988 19.5803 355.787 41.6605 377.867C63.7408 399.947 99.5399 399.947 121.62 377.867Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_299_832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.083 397.432H27.9933C33.0233 374.852 46.5233 370.342 46.5233 370.342L72.5433 358.172L82.4033 358.082H82.6733L92.5433 358.172L118.563 370.342C118.563 370.342 132.053 374.852 137.083 397.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4933 293.313C88.4933 293.313 97.5733 289.263 100.793 296.913C103.893 304.273 91.5833 311.293 91.5833 311.293L88.4933 293.303V293.313Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.513 323.852C71.613 327.252 68.933 330.092 65.533 330.182C62.133 330.282 59.293 327.602 59.203 324.202C59.103 320.802 61.783 317.962 65.183 317.872C68.583 317.782 71.423 320.452 71.513 323.852Z",
    fill: "#FFC5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8634 323.152C61.8634 323.152 64.3134 321.962 66.6434 326.212",
    stroke: "#A8523F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.173 330.182C103.575 330.182 106.333 327.424 106.333 324.022C106.333 320.62 103.575 317.862 100.173 317.862C96.771 317.862 94.013 320.62 94.013 324.022C94.013 327.424 96.771 330.182 100.173 330.182Z",
    fill: "#FFC5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.643 323.052C103.643 323.052 101.163 321.932 98.9427 326.252",
    stroke: "#A8523F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.673 338.222C90.673 338.222 87.203 340.672 84.033 341.282C80.863 341.882 77.793 340.052 77.753 340.032C77.713 340.012 74.053 337.902 74.053 337.902L72.543 358.182L72.953 358.522C78.323 362.952 86.053 363.002 91.483 358.652L92.273 358.012L90.673 338.232V338.222Z",
    fill: "#FFC5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5333 335.762C72.5333 335.762 75.9833 347.062 83.9333 346.932C90.4633 346.832 91.5133 335.762 91.5133 335.762H72.5333Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.403 313.292C99.443 320.252 98.473 326.272 97.503 330.542C96.553 334.722 93.833 337.652 89.973 340.022L89.273 340.452C85.193 342.962 79.913 343.042 75.743 340.672C71.543 338.282 68.593 335.112 67.663 330.632C65.983 322.492 65.753 313.462 65.753 313.462C65.753 313.462 63.383 294.622 81.533 294.872C99.673 295.122 99.393 313.292 99.393 313.292H99.403Z",
    fill: "#FFC5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7523 320.292C75.5642 320.292 76.2224 319.634 76.2224 318.822C76.2224 318.011 75.5642 317.352 74.7523 317.352C73.9405 317.352 73.2823 318.011 73.2823 318.822C73.2823 319.634 73.9405 320.292 74.7523 320.292Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1626 320.292C89.9745 320.292 90.6326 319.634 90.6326 318.822C90.6326 318.011 89.9745 317.352 89.1626 317.352C88.3507 317.352 87.6926 318.011 87.6926 318.822C87.6926 319.634 88.3507 320.292 89.1626 320.292Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6222 320.963V325.013H83.2422",
    stroke: "#A8523F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2826 312.612L78.8726 311.752C78.8726 311.752 78.0126 309.262 74.1326 309.672C70.1626 310.082 69.2726 312.622 69.2726 312.622L69.2826 312.612Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.013 312.612L84.423 311.752C84.423 311.752 85.283 309.262 89.163 309.672C93.133 310.082 94.0229 312.622 94.0229 312.622L94.013 312.612Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3429 328.372H86.8029C86.8029 328.372 86.3629 331.272 81.9329 331.272C77.5029 331.272 77.3429 328.372 77.3429 328.372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.373 322.382C66.373 322.382 69.063 302.012 67.743 298.652C67.743 298.652 58.603 306.212 66.373 322.382Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7134 322.212C98.7134 322.212 95.6934 302.752 96.5334 297.162C96.5334 297.162 105.353 304.982 98.7134 322.212Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9028 295.772L87.5328 294.502L86.7928 293.052L82.3728 293.722L77.9528 293.052L77.2128 294.502L68.8428 295.772L67.7228 300.252L68.0028 305.412C68.0028 305.412 69.3228 299.562 73.9328 300.722C75.0228 300.992 76.3228 301.452 77.8428 301.762C79.2628 302.072 80.6228 302.212 81.8928 302.232C82.0428 302.232 82.2028 302.232 82.3528 302.232C82.5028 302.232 82.6628 302.232 82.8128 302.232C84.0928 302.212 85.4428 302.072 86.8628 301.762C88.3828 301.452 89.7128 301.092 90.7728 300.722C95.0428 299.232 96.6228 305.142 96.6228 305.142L96.9828 300.252L95.8628 295.772H95.9028Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7327 300.872C95.7327 300.872 90.2927 305.732 83.3227 301.992C83.3227 301.992 65.5927 312.912 60.5827 301.022C56.4127 291.112 73.7327 277.652 91.6027 292.812L95.7327 300.862V300.872Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5338 358.172L66.7238 360.842C66.7238 360.842 66.6638 370.592 82.4538 370.082C98.6538 369.562 98.5538 360.992 98.5538 360.992L92.2638 358.002L72.5338 358.172Z",
    fill: "#FFC5AE"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M458.35 256.246H387.529C361.997 256.246 341.299 276.944 341.299 302.477V373.298C341.299 398.83 361.997 419.528 387.529 419.528H458.35C483.882 419.528 504.58 398.83 504.58 373.298V302.477C504.58 276.944 483.882 256.246 458.35 256.246Z",
    fill: "#E34545"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M462.919 377.867C484.999 355.787 484.999 319.988 462.919 297.907C440.838 275.827 405.039 275.827 382.959 297.907C360.879 319.988 360.879 355.787 382.959 377.867C405.039 399.947 440.838 399.947 462.919 377.867Z",
    fill: "#F7D8BA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_299_832",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 366,
    y: 281,
    width: 114,
    height: 114
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M462.919 377.867C484.999 355.787 484.999 319.988 462.919 297.907C440.838 275.827 405.039 275.827 382.959 297.907C360.879 319.988 360.879 355.787 382.959 377.867C405.039 399.947 440.838 399.947 462.919 377.867Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_299_832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.625 397.44H368.535C373.565 374.86 387.065 370.35 387.065 370.35L413.085 358.18L422.945 358.09H423.215L433.085 358.18L459.105 370.35C459.105 370.35 472.595 374.86 477.625 397.44Z",
    fill: "#4570B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.054 323.85C412.154 327.25 409.474 330.09 406.074 330.18C402.674 330.28 399.834 327.6 399.744 324.2C399.644 320.8 402.324 317.96 405.724 317.87C409.124 317.78 411.964 320.45 412.054 323.85Z",
    fill: "#FFC5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.405 323.15C402.405 323.15 404.855 321.96 407.185 326.21",
    stroke: "#A8523F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.714 330.18C444.116 330.18 446.874 327.422 446.874 324.02C446.874 320.618 444.116 317.86 440.714 317.86C437.312 317.86 434.554 320.618 434.554 324.02C434.554 327.422 437.312 330.18 440.714 330.18Z",
    fill: "#FFC5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.184 323.06C444.184 323.06 441.704 321.94 439.484 326.26",
    stroke: "#A8523F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.205 338.22C431.205 338.22 427.735 340.67 424.565 341.28C421.395 341.89 418.325 340.05 418.285 340.03C418.245 340.01 414.585 337.9 414.585 337.9L413.075 358.18L413.485 358.52C418.855 362.95 426.585 363 432.015 358.65L432.805 358.01L431.205 338.23V338.22Z",
    fill: "#FFC5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.075 335.76C413.075 335.76 416.525 347.06 424.475 346.93C431.005 346.83 432.055 335.76 432.055 335.76H413.075Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.945 313.29C439.985 320.25 439.015 326.27 438.045 330.54C437.095 334.72 434.375 337.65 430.515 340.02L429.815 340.45C425.735 342.96 420.455 343.04 416.285 340.67C412.085 338.28 409.135 335.11 408.205 330.63C406.525 322.49 406.295 313.46 406.295 313.46C406.295 313.46 403.925 294.62 422.075 294.87C440.215 295.12 439.935 313.29 439.935 313.29H439.945Z",
    fill: "#FFC5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.295 320.29C416.107 320.29 416.765 319.632 416.765 318.82C416.765 318.008 416.107 317.35 415.295 317.35C414.483 317.35 413.825 318.008 413.825 318.82C413.825 319.632 414.483 320.29 415.295 320.29Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.695 320.29C430.507 320.29 431.165 319.632 431.165 318.82C431.165 318.008 430.507 317.35 429.695 317.35C428.883 317.35 428.225 318.008 428.225 318.82C428.225 319.632 428.883 320.29 429.695 320.29Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.165 320.96V325.01H423.785",
    stroke: "#A8523F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.825 312.61L419.415 311.75C419.415 311.75 418.555 309.26 414.675 309.67C410.705 310.08 409.815 312.62 409.815 312.62L409.825 312.61Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.555 312.61L424.965 311.75C424.965 311.75 425.825 309.26 429.705 309.67C433.675 310.08 434.565 312.62 434.565 312.62L434.555 312.61Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.885 328.37H427.345C427.345 328.37 426.905 331.27 422.475 331.27C418.045 331.27 417.885 328.37 417.885 328.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.914 322.38C406.914 322.38 409.604 302.01 408.284 298.65C408.284 298.65 399.144 306.21 406.914 322.38Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.255 322.22C439.255 322.22 436.235 302.76 437.075 297.17C437.075 297.17 445.895 304.99 439.255 322.22Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.434 292.86L428.064 291.21L427.324 289.33L422.904 290.2L418.484 289.33L417.744 291.21L409.374 292.86L408.254 298.69L408.534 305.41C408.534 305.41 409.854 297.79 414.464 299.31C415.554 299.67 416.854 300.26 418.374 300.66C419.794 301.06 421.154 301.25 422.424 301.27C422.574 301.27 422.734 301.27 422.884 301.27C423.034 301.27 423.194 301.27 423.344 301.27C424.624 301.24 425.974 301.06 427.394 300.66C428.914 300.26 430.244 299.79 431.304 299.31C435.574 297.37 437.154 305.07 437.154 305.07L437.514 298.7L436.394 292.87L436.434 292.86Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.075 358.17L407.265 360.84C407.265 360.84 407.205 370.59 422.995 370.08C439.195 369.56 439.095 360.99 439.095 360.99L432.805 358L413.075 358.17Z",
    fill: "#FFC5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.545 303.82C406.545 305.85 404.905 307.49 402.875 307.49C400.845 307.49 399.205 305.85 399.205 303.82C399.205 301.79 400.845 300.15 402.875 300.15C404.905 300.15 406.545 301.79 406.545 303.82Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.615 310.21C406.615 311.92 405.235 313.3 403.525 313.3C401.815 313.3 400.435 311.92 400.435 310.21C400.435 308.5 401.815 307.12 403.525 307.12C405.235 307.12 406.615 308.5 406.615 310.21Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.505 309.69C445.505 311.4 444.125 312.78 442.415 312.78C440.705 312.78 439.325 311.4 439.325 309.69C439.325 307.98 440.705 306.6 442.415 306.6C444.125 306.6 445.505 307.98 445.505 309.69Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.275 298.65C409.275 300.68 407.635 302.32 405.605 302.32C403.575 302.32 401.935 300.68 401.935 298.65C401.935 296.62 403.575 294.98 405.605 294.98C407.635 294.98 409.275 296.62 409.275 298.65Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.955 293.77C412.955 295.8 411.315 297.44 409.285 297.44C407.255 297.44 405.615 295.8 405.615 293.77C405.615 291.74 407.255 290.1 409.285 290.1C411.315 290.1 412.955 291.74 412.955 293.77Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.295 290.93C418.295 292.96 416.655 294.6 414.625 294.6C412.595 294.6 410.955 292.96 410.955 290.93C410.955 288.9 412.595 287.26 414.625 287.26C416.655 287.26 418.295 288.9 418.295 290.93Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.705 289.7C423.705 291.73 422.065 293.37 420.035 293.37C418.005 293.37 416.365 291.73 416.365 289.7C416.365 287.67 418.005 286.03 420.035 286.03C422.065 286.03 423.705 287.67 423.705 289.7Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.785 303.82C439.785 305.85 441.425 307.49 443.455 307.49C445.485 307.49 447.125 305.85 447.125 303.82C447.125 301.79 445.485 300.15 443.455 300.15C441.425 300.15 439.785 301.79 439.785 303.82Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.054 298.65C437.054 300.68 438.694 302.32 440.724 302.32C442.754 302.32 444.394 300.68 444.394 298.65C444.394 296.62 442.754 294.98 440.724 294.98C438.694 294.98 437.054 296.62 437.054 298.65Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.375 293.77C433.375 295.8 435.015 297.44 437.045 297.44C439.075 297.44 440.715 295.8 440.715 293.77C440.715 291.74 439.075 290.1 437.045 290.1C435.015 290.1 433.375 291.74 433.375 293.77Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.035 290.93C428.035 292.96 429.675 294.6 431.705 294.6C433.735 294.6 435.375 292.96 435.375 290.93C435.375 288.9 433.735 287.26 431.705 287.26C429.675 287.26 428.035 288.9 428.035 290.93Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.625 289.7C422.625 291.73 424.265 293.37 426.295 293.37C428.325 293.37 429.965 291.73 429.965 289.7C429.965 287.67 428.325 286.03 426.295 286.03C424.265 286.03 422.625 287.67 422.625 289.7Z",
    fill: "#1E0B02"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.052 85.7078H46.231C20.6988 85.7078 0.000976562 106.406 0.000976562 131.938V202.759C0.000976562 228.291 20.6988 248.989 46.231 248.989H117.052C142.584 248.989 163.282 228.291 163.282 202.759V131.938C163.282 106.406 142.584 85.7078 117.052 85.7078Z",
    fill: "#7E81F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.791 179.808C143.671 149.349 124.558 119.079 94.0993 112.198C63.6407 105.317 33.371 124.431 26.4901 154.89C19.6092 185.348 38.7227 215.618 69.1813 222.499C99.64 229.38 129.91 210.266 136.791 179.808Z",
    fill: "#F7D8BA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_299_832",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 110,
    width: 114,
    height: 114
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.791 179.808C143.671 149.349 124.558 119.079 94.0993 112.198C63.6407 105.317 33.371 124.431 26.4901 154.89C19.6092 185.348 38.7227 215.618 69.1813 222.499C99.64 229.38 129.91 210.266 136.791 179.808Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_299_832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3581 119.229C70.3581 119.229 78.2981 108.479 92.3681 115.649C107.798 123.509 99.4581 140.459 99.4581 140.459L66.3081 134.179L70.3581 119.229Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7278 140.549C63.7278 140.549 55.0578 123.519 70.3578 119.229L73.1078 128.359L63.7278 140.539V140.549Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0778 148.409C71.1778 151.809 68.4978 154.649 65.0978 154.739C61.6978 154.839 58.8578 152.159 58.7678 148.759C58.6678 145.359 61.3478 142.519 64.7478 142.429C68.1478 142.329 70.9878 145.009 71.0778 148.409Z",
    fill: "#F2AA89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4174 147.709C61.4174 147.709 63.8674 146.519 66.1974 150.769",
    stroke: "#C47268",
    strokeWidth: 0.69,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5678 148.579C93.5678 151.979 96.3278 154.739 99.7278 154.739C103.128 154.739 105.888 151.979 105.888 148.579C105.888 145.179 103.128 142.419 99.7278 142.419C96.3278 142.419 93.5678 145.179 93.5678 148.579Z",
    fill: "#F2AA89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.208 147.619C103.208 147.619 100.728 146.499 98.5082 150.819",
    stroke: "#C47268",
    strokeWidth: 0.69,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2281 162.779C90.2281 162.779 86.7581 165.229 83.5881 165.839C80.4181 166.439 77.3481 164.609 77.3081 164.589C77.2681 164.569 73.6081 162.459 73.6081 162.459L72.0981 182.739L72.5081 183.079C77.8781 187.509 85.6081 187.559 91.0381 183.209L91.8281 182.569L90.2281 162.789V162.779Z",
    fill: "#F2AA89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0981 160.319C72.0981 160.319 75.5481 171.619 83.4981 171.489C90.0281 171.389 91.0781 160.319 91.0781 160.319H72.0981Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9578 137.859C98.9978 144.819 98.0278 150.839 97.0578 155.109C96.1078 159.289 92.4278 162.219 88.5778 164.589L87.8778 165.019C83.7978 167.529 80.4278 167.609 76.2578 165.239C72.0578 162.849 68.1478 159.679 67.2278 155.199C65.5478 147.059 65.3178 138.029 65.3178 138.029C65.3178 138.029 62.9478 119.189 81.0978 119.439C99.2378 119.689 98.9578 137.859 98.9578 137.859Z",
    fill: "#F2AA89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7774 143.38C75.7774 144.19 75.1174 144.85 74.3074 144.85C73.4974 144.85 72.8374 144.19 72.8374 143.38C72.8374 142.57 73.4974 141.91 74.3074 141.91C75.1174 141.91 75.7774 142.57 75.7774 143.38Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1874 143.38C90.1874 144.19 89.5274 144.85 88.7174 144.85C87.9074 144.85 87.2474 144.19 87.2474 143.38C87.2474 142.57 87.9074 141.91 88.7174 141.91C89.5274 141.91 90.1874 142.57 90.1874 143.38Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.187 147.22V149.57H82.087",
    stroke: "#C47268",
    strokeWidth: 0.69,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8474 137.17L78.4374 136.31C78.4374 136.31 77.5774 133.82 73.6974 134.23C69.7274 134.64 68.8374 137.18 68.8374 137.18L68.8474 137.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.567 137.17L83.977 136.31C83.977 136.31 84.837 133.82 88.717 134.23C92.687 134.64 93.577 137.18 93.577 137.18L93.567 137.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8969 152.93H86.3569C86.3569 152.93 85.9169 155.83 81.4869 155.83C77.0569 155.83 76.8969 152.93 76.8969 152.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9375 146.939C65.9375 146.939 66.6475 123.869 66.3575 123.209C66.3575 123.209 58.1775 130.769 65.9375 146.939Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2775 146.779L97.0475 121.729C97.0475 121.729 104.917 129.549 98.2775 146.779Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5275 121.16C73.5275 121.16 67.8975 122.68 68.0875 128.21C68.2775 133.74 64.5375 139.17 64.5375 139.17L62.8275 133.65C62.8275 133.65 61.5075 123.36 73.5175 121.16H73.5275Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1078 121.619C72.1078 121.619 76.3178 119.229 80.5078 124.489C84.0778 128.979 93.4978 133.609 99.0778 129.209C99.0778 129.209 95.5278 116.489 81.6578 116.749C67.7978 117.009 72.0978 121.619 72.0978 121.619H72.1078Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.478 225.489H34.0778C35.8178 218.269 37.6078 211.849 39.3778 206.849C41.9978 199.469 45.7678 195.149 48.8878 192.689C51.9978 190.219 54.4578 189.599 54.4578 189.599L61.0778 186.829L102.958 186.869L109.098 189.599C109.098 189.599 118.938 192.079 124.178 206.849C125.948 211.849 127.738 218.269 129.478 225.489Z",
    fill: "#EF758D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5178 177.999L102.958 186.859C102.958 186.859 81.9578 205.839 61.0778 186.819L82.5178 177.999Z",
    fill: "#F2AA89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0778 186.819C61.0778 186.819 68.3578 195.429 81.9678 195.429C95.5778 195.429 102.958 186.859 102.958 186.859",
    stroke: "white",
    strokeWidth: 1.94,
    strokeMiterlimit: 10
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M458.35 85.7078H387.529C361.997 85.7078 341.299 106.406 341.299 131.938V202.759C341.299 228.291 361.997 248.989 387.529 248.989H458.35C483.882 248.989 504.58 228.291 504.58 202.759V131.938C504.58 106.406 483.882 85.7078 458.35 85.7078Z",
    fill: "#7E81F7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M478.039 180.029C485.042 149.598 466.05 119.252 435.619 112.249C405.188 105.246 374.842 124.238 367.839 154.668C360.836 185.099 379.828 215.445 410.259 222.448C440.689 229.451 471.035 210.46 478.039 180.029Z",
    fill: "#F7D8BA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_299_832",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 366,
    y: 110,
    width: 114,
    height: 114
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M478.039 180.029C485.042 149.598 466.05 119.252 435.619 112.249C405.188 105.246 374.842 124.238 367.839 154.668C360.836 185.099 379.828 215.445 410.259 222.448C440.689 229.451 471.035 210.46 478.039 180.029Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_299_832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.856 191.783L398.456 222.443H378.996C381.026 217.683 383.406 211.953 385.596 206.333C390.526 193.633 399.886 191.933 400.786 191.793C400.836 191.783 400.856 191.783 400.856 191.783Z",
    fill: "#D3445B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.366 222.443H450.376L447.186 191.433C447.186 191.433 447.206 191.443 447.216 191.443C447.866 191.523 458.266 193.153 463.636 206.333C466.036 212.233 468.436 217.923 470.366 222.443Z",
    fill: "#D3445B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.396 222.444L422.946 228.294L396.876 222.444L396.976 193.474C398.106 192.774 399.446 192.224 400.786 191.794C403.996 190.774 407.136 190.484 407.136 190.484L424.616 192.244L442.096 190.484C442.096 190.484 444.466 190.704 447.186 191.434C447.186 191.434 447.206 191.444 447.216 191.444C448.916 191.894 450.756 192.554 452.246 193.474L452.396 222.444Z",
    fill: "#D3445B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.856 191.774L421.456 186.364H428.556L447.186 191.434C437.656 200.364 414.016 207.684 401.916 192.194L400.856 191.774Z",
    fill: "#F2AA89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.666 172.923C454.476 171.293 454.596 169.623 455.006 168.063C457.086 160.093 454.706 153.313 450.506 148.233C446.706 143.643 445.756 136.863 445.756 136.863C442.966 127.673 433.516 121.293 424.916 121.293C416.316 121.293 406.886 127.303 404.096 136.493C404.096 136.493 402.836 143.773 399.326 148.233C395.256 153.403 392.746 160.093 394.826 168.063C395.236 169.633 395.366 171.303 395.166 172.923C395.026 174.123 394.696 175.373 394.006 176.233H455.816C455.126 175.373 454.806 174.123 454.656 172.923H454.666Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.206 155.434C414.296 158.774 411.666 161.554 408.326 161.654C404.986 161.744 402.206 159.114 402.106 155.774C402.016 152.434 404.646 149.644 407.986 149.554C411.326 149.464 414.106 152.094 414.206 155.434Z",
    fill: "#F2AA89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.726 154.753C404.726 154.753 407.136 153.583 409.426 157.763",
    stroke: "#C47268",
    strokeWidth: 0.69,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.306 155.603C436.306 158.943 439.016 161.653 442.356 161.653C445.696 161.653 448.406 158.943 448.406 155.603C448.406 152.263 445.696 149.553 442.356 149.553C439.016 149.553 436.306 152.263 436.306 155.603Z",
    fill: "#F2AA89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.765 154.654C445.765 154.654 443.325 153.554 441.155 157.794",
    stroke: "#C47268",
    strokeWidth: 0.69,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.086 163.083C435.579 163.083 444.086 154.577 444.086 144.083C444.086 133.59 435.579 125.083 425.086 125.083C414.592 125.083 406.086 133.59 406.086 144.083C406.086 154.577 414.592 163.083 425.086 163.083Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.095 167.684C431.095 167.684 428.475 170.084 426.085 170.674C423.695 171.264 421.375 169.454 421.345 169.434C421.315 169.414 418.555 167.344 418.555 167.344L417.435 187.254L417.745 187.584C421.795 191.934 427.635 191.994 431.725 187.724L432.325 187.104L431.095 167.674V167.684Z",
    fill: "#F2AA89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.676 164.714C416.676 164.714 420.036 176.353 426.026 176.233C430.956 176.143 432.326 165.294 432.326 165.294L416.676 164.714Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.586 144.293C441.616 150.843 440.676 156.493 439.716 160.503C438.776 164.433 436.106 167.193 432.326 169.413L431.636 169.823C427.626 172.183 422.436 172.263 418.346 170.033C414.216 167.783 411.326 164.803 410.416 160.593C408.766 152.943 408.546 144.453 408.546 144.453C408.546 144.453 407.166 126.743 424.986 126.973C442.806 127.203 441.586 144.283 441.586 144.283V144.293Z",
    fill: "#F2AA89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.636 153.993V156.583H425.386",
    stroke: "#C47268",
    strokeWidth: 0.69,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.536 144.143L420.956 143.293C420.956 143.293 420.116 140.853 416.306 141.243C412.406 141.653 411.536 144.133 411.536 144.133V144.143Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.437 144.143L428.017 143.293C428.017 143.293 428.857 140.853 432.667 141.243C436.567 141.653 437.437 144.133 437.437 144.133V144.143Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.366 158.973H429.656C429.656 158.973 429.266 161.653 424.326 161.653C420.276 161.653 419.366 158.973 419.366 158.973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.847 150.493C419.847 150.493 417.407 148.503 415.267 150.493",
    stroke: "#1E0B02",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.616 150.493C433.616 150.493 431.706 148.453 429.156 150.493",
    stroke: "#1E0B02",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M415.276 143.983L422.186 153.363C422.186 153.363 420.106 157.343 416.786 156.903L409.816 147.753C409.816 147.753 411.696 143.733 415.276 143.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M432.266 143.983L439.176 153.363C439.176 153.363 437.096 157.343 433.776 156.903L426.806 147.753C426.806 147.753 428.686 143.733 432.266 143.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.736 150.493C422.736 154.223 419.716 157.243 415.986 157.243C412.256 157.243 409.236 154.223 409.236 150.493C409.236 146.763 412.256 143.743 415.986 143.743C419.716 143.743 422.736 146.763 422.736 150.493Z",
    stroke: "white",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.736 150.493C439.736 154.223 436.716 157.243 432.986 157.243C429.256 157.243 426.236 154.223 426.236 150.493C426.236 146.763 429.256 143.743 432.986 143.743C436.716 143.743 439.736 146.763 439.736 150.493Z",
    stroke: "white",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.736 150.493C422.736 150.493 424.666 149.783 426.236 150.493",
    stroke: "white",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.836 140.263C406.836 140.263 422.716 137.243 425.996 125.383C425.996 125.383 409.096 119.383 406.836 140.263Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.586 140.263C441.586 140.263 425.706 137.243 422.426 125.383C422.426 125.383 439.326 119.383 441.586 140.263Z",
    fill: "#1E0B02"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M287.935 0.438721H217.114C191.582 0.438721 170.884 21.1367 170.884 46.669V117.49C170.884 143.022 191.582 163.72 217.114 163.72H287.935C313.467 163.72 334.165 143.022 334.165 117.49V46.669C334.165 21.1367 313.467 0.438721 287.935 0.438721Z",
    fill: "#1ED387"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M307.674 94.5384C314.555 64.0798 295.441 33.8101 264.983 26.9292C234.524 20.0483 204.254 39.1618 197.373 69.6204C190.493 100.079 209.606 130.349 240.065 137.23C270.523 144.111 300.793 124.997 307.674 94.5384Z",
    fill: "#F7D8BA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_299_832",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 195,
    y: 25,
    width: 115,
    height: 114
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M307.674 94.5384C314.555 64.0798 295.441 33.8101 264.983 26.9292C234.524 20.0483 204.254 39.1618 197.373 69.6204C190.493 100.079 209.606 130.349 240.065 137.23C270.523 144.111 300.793 124.997 307.674 94.5384Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_299_832)"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M235.65 53.4831C235.65 53.4831 233.1 68.0531 215.57 78.6331C196.88 89.9131 207.53 125.743 240.26 126.533C275.81 127.393 293.88 82.9731 273.33 46.7031L235.65 53.4831Z",
    fill: "#D46919"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M294.69 115.843C292.86 110.963 287.26 104.553 276.42 102.853L256.21 98.8832L236 102.853C225.16 104.553 219.56 110.963 217.73 115.843L213.5 134.963H232.04L233.39 136.513L255.89 140.943L279.02 134.973H298.92L294.68 115.853L294.69 115.843Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M235.37 103.063L257.28 98.6232L277.73 103.003L277.28 103.333C264.78 112.323 247.97 111.913 235.37 103.073V103.063Z",
    fill: "#FFC5AE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M245.28 70.6431C245.41 73.9031 242.86 76.6531 239.6 76.7831C236.34 76.9131 233.59 74.3631 233.46 71.1031C233.33 67.8431 235.88 65.0931 239.14 64.9631C242.4 64.8331 245.15 67.3831 245.28 70.6431Z",
    fill: "#FFC5AE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M236 70.0732C236 70.0732 238.34 68.9032 240.62 72.9632",
    stroke: "#B9635E",
    strokeWidth: 0.66,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M266.879 70.5831C266.909 73.8531 269.589 76.4731 272.859 76.4331C276.129 76.4031 278.749 73.7231 278.709 70.4531C278.679 67.1831 275.999 64.5631 272.729 64.6031C269.459 64.6331 266.839 67.3131 266.879 70.5831Z",
    fill: "#FFC5AE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M276.109 69.5632C276.109 69.5632 273.719 68.5132 271.629 72.6832",
    stroke: "#B9635E",
    strokeWidth: 0.66,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M255.961 75.307C267.199 75.1913 276.222 66.5958 276.114 56.1085C276.006 45.6211 266.808 37.2133 255.57 37.329C244.331 37.4448 235.308 46.0402 235.416 56.5276C235.524 67.0149 244.722 75.4227 255.961 75.307Z",
    fill: "#D46919"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M261.91 82.443C261.91 82.443 259.38 84.823 257.05 85.423C254.72 86.023 252.43 84.283 252.4 84.263C252.37 84.243 249.65 82.243 249.65 82.243L248.76 101.723L249.07 102.043C253.08 106.263 258.78 106.263 262.73 102.043L263.31 101.423L261.91 82.443Z",
    fill: "#FFC5AE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M247.78 79.683C247.78 79.683 251.18 91.023 257.03 90.853C261.84 90.713 263.07 80.093 263.07 80.093L247.77 79.683H247.78Z",
    fill: "#1E0B02"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M271.93 59.4731C272.03 65.8731 271.16 71.4031 270.27 75.3431C269.4 79.1931 266.81 81.9131 263.13 84.1331L262.46 84.5331C258.57 86.8731 253.5 87.0131 249.47 84.8731C245.41 82.7131 242.55 79.8331 241.62 75.7331C239.93 68.2731 239.63 59.9831 239.63 59.9831C239.63 59.9831 238.1 42.6931 255.52 42.7331C272.94 42.7831 271.92 59.4831 271.92 59.4831L271.93 59.4731Z",
    fill: "#FFC5AE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M254.48 68.5031L254.5 71.0031L256.21 70.9831",
    stroke: "#B9635E",
    strokeWidth: 0.66,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M242.55 59.633L251.75 58.703C251.75 58.703 250.9 56.323 247.18 56.753C243.37 57.193 242.55 59.633 242.55 59.633Z",
    fill: "#D46919"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M267.87 59.373L258.65 58.633C258.65 58.633 259.45 56.243 263.18 56.583C266.99 56.943 267.87 59.363 267.87 59.363V59.373Z",
    fill: "#D46919"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M249.76 65.1631C249.76 65.9431 249.14 66.5831 248.36 66.5831C247.58 66.5831 246.94 65.9631 246.94 65.1831C246.94 64.4031 247.56 63.7631 248.34 63.7631C249.12 63.7631 249.76 64.3831 249.76 65.1631Z",
    fill: "#1E0B02"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M263.59 65.0232C263.59 65.8032 262.97 66.4432 262.19 66.4432C261.41 66.4432 260.77 65.8232 260.77 65.0432C260.77 64.2632 261.39 63.6232 262.17 63.6232C262.95 63.6232 263.59 64.2432 263.59 65.0232Z",
    fill: "#1E0B02"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M250.23 74.593C250.23 74.593 254.17 76.683 260.46 74.483",
    stroke: "black",
    strokeWidth: 0.66,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M271.89 55.5431C271.89 55.5431 246.26 56.7731 247.19 41.7231C247.19 41.7231 269.47 35.1631 271.89 55.5431Z",
    fill: "#D46919"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M239.22 55.8931C239.22 55.8931 248.19 52.0331 248.09 42.8031C248.09 42.8031 238.87 43.9631 239.22 55.8931Z",
    fill: "#D46919"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_299_832",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 213,
    y: 102,
    width: 86,
    height: 34
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M294.69 115.983C292.93 111.243 287.67 105.083 277.62 103.083L277.28 103.333C264.78 112.423 247.97 112.003 235.37 103.063L236 102.853C225.16 104.573 219.56 111.053 217.73 115.983L213.49 135.303H298.92L294.69 115.983Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_299_832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.04 105.203H300.76",
    stroke: "#EF758D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.04 109.883H300.76",
    stroke: "#EF758D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.04 114.573H300.76",
    stroke: "#EF758D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.04 119.253H300.76",
    stroke: "#EF758D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.04 123.933H300.76",
    stroke: "#EF758D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.04 128.623H300.76",
    stroke: "#EF758D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.04 133.303H300.76",
    stroke: "#EF758D",
    strokeMiterlimit: 10
  })))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M287.934 170.977H217.113C191.581 170.977 170.883 191.675 170.883 217.207V288.028C170.883 313.56 191.581 334.258 217.113 334.258H287.934C313.466 334.258 334.164 313.56 334.164 288.028V217.207C334.164 191.675 313.466 170.977 287.934 170.977Z",
    fill: "#7E81F7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M307.474 265.932C314.827 235.584 296.186 205.021 265.838 197.668C235.49 190.315 204.927 208.956 197.574 239.304C190.22 269.652 208.861 300.215 239.21 307.568C269.558 314.921 300.121 296.28 307.474 265.932Z",
    fill: "#FFD9BA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_299_832",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 195,
    y: 196,
    width: 115,
    height: 114
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M307.474 265.932C314.827 235.584 296.186 205.021 265.838 197.668C235.49 190.314 204.927 208.955 197.574 239.303C190.22 269.652 208.861 300.214 239.21 307.568C269.558 314.921 300.121 296.28 307.474 265.932Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_299_832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.639 301.85C288.809 296.97 283.209 290.56 272.369 288.86L252.159 284.89L231.949 288.86C221.109 290.56 215.509 296.97 213.679 301.85L209.439 320.97H294.869L290.639 301.85Z",
    fill: "#D3445B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.329 289.07L253.239 284.63L273.689 289.01L273.239 289.34C260.739 298.33 243.929 297.92 231.329 289.08V289.07Z",
    fill: "#F2AA89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.24 256.65C241.37 259.91 238.82 262.66 235.56 262.79C232.3 262.92 229.55 260.37 229.42 257.11C229.29 253.85 231.84 251.1 235.1 250.97C238.36 250.84 241.11 253.39 241.24 256.65Z",
    fill: "#F2AA89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.96 256.09C231.96 256.09 234.3 254.92 236.58 258.98",
    stroke: "black",
    strokeWidth: 0.66,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.829 256.6C262.859 259.87 265.539 262.49 268.809 262.45C272.079 262.42 274.699 259.74 274.659 256.47C274.629 253.2 271.949 250.58 268.679 250.62C265.409 250.65 262.789 253.33 262.829 256.6Z",
    fill: "#F2AA89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.07 255.58C272.07 255.58 269.68 254.53 267.59 258.7",
    stroke: "black",
    strokeWidth: 0.66,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.908 261.33C263.146 261.214 272.169 252.618 272.061 242.131C271.953 231.644 262.755 223.236 251.517 223.352C240.278 223.467 231.255 232.063 231.363 242.55C231.471 253.038 240.669 261.445 251.908 261.33Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.86 268.46C257.86 268.46 255.33 270.84 253 271.44C250.67 272.04 248.38 270.3 248.35 270.28C248.32 270.26 245.6 268.26 245.6 268.26L244.71 287.74L245.02 288.06C249.03 292.28 254.73 292.28 258.68 288.06L259.26 287.44L257.86 268.46Z",
    fill: "#F2AA89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.739 265.7C243.739 265.7 247.139 277.04 252.989 276.87C257.799 276.73 259.029 266.11 259.029 266.11L243.729 265.7H243.739Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.89 245.49C267.99 251.89 267.12 257.42 266.23 261.36C265.36 265.21 262.77 267.93 259.09 270.15L258.42 270.55C254.53 272.89 249.46 273.03 245.43 270.89C241.37 268.73 238.51 265.85 237.58 261.75C235.89 254.29 235.59 246 235.59 246C235.59 246 234.06 228.71 251.48 228.75C268.9 228.8 267.88 245.5 267.88 245.5L267.89 245.49Z",
    fill: "#F2AA89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.43 254.51L250.46 257.01L252.17 257",
    stroke: "#684138",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.51 245.65L247.71 244.72C247.71 244.72 246.86 242.34 243.14 242.77C239.33 243.21 238.51 245.65 238.51 245.65Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.82 245.38L254.6 244.64C254.6 244.64 255.4 242.25 259.13 242.59C262.94 242.95 263.82 245.37 263.82 245.37V245.38Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.719 251.17C245.719 251.95 245.099 252.59 244.319 252.59C243.539 252.59 242.899 251.97 242.899 251.19C242.899 250.41 243.519 249.77 244.289 249.77C245.069 249.77 245.709 250.39 245.709 251.17H245.719Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.549 251.03C259.549 251.81 258.929 252.45 258.149 252.45C257.369 252.45 256.729 251.83 256.729 251.05C256.729 250.27 257.349 249.63 258.129 249.63C258.909 249.63 259.549 250.25 259.549 251.03Z",
    fill: "#1E0B02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.18 260.61C246.18 260.61 250.12 262.7 256.41 260.5",
    stroke: "black",
    strokeWidth: 0.66,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.85 241.55C267.85 241.55 242.22 242.78 243.15 227.73C243.15 227.73 265.43 221.17 267.85 241.55Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.17 241.9C235.17 241.9 244.14 238.04 244.04 228.81C244.04 228.81 234.82 229.97 235.17 241.9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.08 225.67C257.702 225.67 263.07 220.302 263.07 213.68C263.07 207.058 257.702 201.69 251.08 201.69C244.458 201.69 239.09 207.058 239.09 213.68C239.09 220.302 244.458 225.67 251.08 225.67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.589 221.28C250.589 225 247.399 228.02 243.479 228.02C239.559 228.02 236.369 225 236.369 221.28C236.369 217.56 239.559 214.54 243.479 214.54C247.399 214.54 250.589 217.56 250.589 221.28Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.179 229.28C263.686 229.28 266.529 226.437 266.529 222.93C266.529 219.423 263.686 216.58 260.179 216.58C256.672 216.58 253.829 219.423 253.829 222.93C253.829 226.437 256.672 229.28 260.179 229.28Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainersImage);
export default __webpack_public_path__ + "static/media/trainersImage.4467ef99e02bd99c0e8cfb60e7d670d6.svg";
export { ForwardRef as ReactComponent };